<script setup>
import { formattedDate, swalError, swalSuccess } from '@/helper';
import { delete_ticket, get_ticket, update_ticket } from '@/services/tickets';
import { get_user } from '@/services/user';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute()
const ticket = ref({})
const user = ref({})
const isLoading = ref(true)
onMounted(async()=>{
  try {
    await retrieve_ticket()
    if (ticket.value.id){
      await retrieve_user()
      if (ticket.value.attributes.ticket_type == 'system_feedback'){
        questions.value = parseQuestionaire(ticket.value.attributes.meta)
      }
    }
  } catch (error) {
    console.error("Failed to load ticket details:", error)
    swalError(error.message || error, false)
  } finally {
    isLoading.value = false
  }
})

async function retrieve_ticket(){
  let response = await get_ticket(route.params.id)
  if (response.error || !response.result){
    const errorMsg = response.result?.error || response.message || response.result || 'Unknown error occurred or empty response';
    swalError(errorMsg, false)
    return
  }
  ticket.value = response.result.data.data
}

async function retrieve_user(){
  let response = await get_user(ticket.value.attributes.user_id)
  if (response.error){
    const errorMsg = response.message || 'Failed to retrieve user';
    swalError(errorMsg, false)
    return
  }
  user.value = response.data.data.attributes
}

function parseDate(date){
  return formattedDate(date)
}

const questions = ref([])
function parseQuestionaire(data){
  let formatted
  formatted = JSON.parse(data)
  return formatted
}

function getText(data){
  let text = ''
  switch (data) {
    case 'support':
      text = 'support ticket'
      break;
    case 'feedback':
      text = 'feedback'
      break;
    case 'system_feedback':
      text = 'feedback'
      break;
    default:
      break;
  }
  return text
}

async function archiveTicket(){
  Swal.fire({
    title: 'Are you sure?',
    text: "Do you really want to archive this ticket?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, archive it!',
    customClass: {
      cancelButton: 'text-white'
    }
  }).then(async (result) => {
    if (result.isConfirmed) {
      let params = {
        is_archive: 1
      }
      let response = await update_ticket(ticket.value.id, params)
      if(response.error){
        const errorMsg = response.message || response.result || 'Failed to archive ticket';
        swalError(errorMsg, false)
        return
      }
      ticket.value.attributes.is_archive = 1
      swalSuccess("Ticket has been archived")
    }
  })
}
</script>

<template>
  <Breadcrumbs main="System Feedback Ticket"/>
  <div class="container-fluid">
    <template v-if="isLoading">
      <loadingCard />
    </template>
    <div v-else-if="ticket.id" class="row">
      <!-- User Info -->
      <div class="col-md-6 card">
        <div class="card-header py-3">
          <h4 class="mb-0">User Info</h4>
        </div>
        <div class="card-body">
          <p class="mb-0">
            <b>Name:</b>
            {{ user.first_name }} {{ user.last_name }}
          </p>
          <p class="mb-0">
            <b>Email:</b>
            {{ user.email }}
          </p>
          <p class="mb-0">
            <b>Register On:</b>
            {{ parseDate(user.created_at) }}
          </p>
        </div>
      </div>

      <!-- Ticket Info -->
      <div class="card">
        <div class="card-header py-3">
          <div class="d-flex justify-content-between">
            <h4 class="mb-0">{{ ticket.attributes.topic }}</h4>
            <button class="btn btn-light-danger" 
              @click='archiveTicket()'
              :class="ticket.attributes.is_archive ? 'disabled' : ''"
            >
              Archive {{ getText(ticket.attributes.ticket_type) }}
            </button>

          </div>
        </div>
        <div class="card-body pt-3">
          <div class="card shadow-none border mt-3">
            <div v-if="ticket.attributes.ticket_type == 'support'" class="card-body">
              <p>{{ ticket.attributes.description }}</p>
            </div>
            <div v-if="ticket.attributes.ticket_type == 'feedback'" class="card-body">
              <div v-for="item in questions" class="mb-3">
                <p class="mb-0 fw-medium tracking-widest">{{ item.title }}</p>
                <p>Answer: {{ item.answer }}</p>
              </div>
            </div>
            <div v-if="ticket.attributes.ticket_type == 'system_feedback'" class="card-body">
              <div v-for="item in questions" class="mb-3">
                <p class="mb-0 fw-medium tracking-widest">{{ item.title }}</p>
                <p>Answer: {{ item.answer }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="card">
      <div class="card-body text-center">
        <h4>Unable to load ticket</h4>
        <p>Please check if the ticket ID is valid or try again later.</p>
      </div>
    </div>
  </div>
</template>

<style>
.swal2-cancel.text-white {
  color: #fff !important;
}
</style>